<template>
  <div>
    <h2 class="mb-3">Order History</h2>

    <div class="card border-0 shadow-sm">
      <div class="card-body">
        <p class="text-muted text-center my-4">Order history is not available at the moment</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderHistory'
}
</script>



// WEBPACK FOOTER //
// src/components/order/partials/History.vue